import { createApiClient } from '@lyrmo/client';

export {
  createApiClient,
  parseRetryAfter,
  type ApiClient,
  type ApiClientOptions,
  type RewriteClient,
} from '@lyrmo/client';

export const apiClient = createApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  clientName: 'web',
});
